import { Location } from '@angular/common';
import { Injectable, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService{

  private history: string[] = ['/'];
  constructor(
    private router: Router,
    private location: Location
  ) {
   }

  startSaveHistory(): void{
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd){
        if(this.history.length > 2){
          this.history.shift()
        }
        if(event.urlAfterRedirects !== '/404'){
          this.history.push(event.urlAfterRedirects)
        }

      }
    })
  }

  getHistory(): string[]{
    return this.history;
  }

  goBack(): void {
    if(this.history.length > 0){
      this.location.back()
    } else {
      this.router.navigateByUrl("/")
    }

  }

  getPreviousUrl(): string {
    if(this.history.length > 0){
      return this.history[this.history.length - 2];
    }
    return '';
  }
}
